import variables from '../index.scss';
export const prefixCls = variables.prefixCls;
export const filterCssProperties = (style, names, removed = true) => {
    const results = {};
    names.forEach((name) => {
        if (style?.[name] !== undefined) {
            results[name] = style[name];
            if (removed) {
                delete style[name];
            }
        }
    });
    return results;
};
